import React, { useState } from 'react';
import Link from 'next/link';
import { Box, Flex, Text, Avatar, Image, HStack, Icon, Collapse, useColorMode } from '@chakra-ui/react';
import { Container } from 'components/Container';
import { FaDiscord, FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa';
import IconSocial from 'components/IconSocial';
import { MdMonitor } from 'react-icons/md';
import { useHttpBid } from 'lib/useHttp';
import { parseUsername, priceOne, setHttp, truncate } from 'utils/utility';
import { validURL } from 'lib/utility';
import { FiChevronDown } from 'react-icons/fi';
import { bgColor } from 'config/data';

const CardProfileCollection = ({ title, code, description, username, statistics, collection }) => {
  const { data: usrData } = useHttpBid(`${process.env.NEXT_PUBLIC_API_URL}/user/${username}`, true);
  const userData = usrData?.data;
  const [more, setMore] = useState(false);
  const { colorMode } = useColorMode();
  return (
    <Box
      as="section"
      id="card_profile_collection"
      pt={{ base: '5px', md: '30px' }}
      pb={{ base: '25px', md: '20px' }}
      px={['15px', '10px', 0]}
      bg={
        collection?.banner_file?.thumbnail_http_url
          ? `url(${collection?.banner_file?.thumbnail_http_url}) no-repeat center`
          : '#000'
      }
      bgSize="cover"
      color="white"
      pos="relative"
    >
      <Container>
        <Box pt="45px" pb="40px" px="40px" id="box_profile" zIndex={0}>
          <Flex flexDirection="column" alignItems="center" maxW={['100%', '100%', '450px']} m="0 auto">
            <Flex pos="relative" id="avatar">
              <Avatar
                src={collection?.logo_file?.thumbnail_http_url}
                name={title?.charAt(0)}
                w="120px"
                h="120px"
                mb="10px"
                size="xl"
                bg="#BC3153"
                color="#fff"
              />
              {userData?.is_verified && (
                <Image
                  pos="absolute"
                  bottom="14px"
                  right="0"
                  w="24px"
                  h="24px"
                  src="/images/check_profile.svg"
                  alt=""
                />
              )}
            </Flex>

            <Flex alignItems="center" id="collection_title" color="white">
              <Text fontSize={{ base: '20px', md: '32px' }} fontWeight="bold" py="10x" textAlign="center">
                {title}
              </Text>
            </Flex>

            <Flex id="username" color="white">
              <Link href={`/${userData?.username}`}>
                <a>
                  <Text fontSize="16px" fontWeight="500">
                    {userData?.username}
                  </Text>
                </a>
              </Link>
              {code && (
                <Flex>
                  <Image
                    src={`https://flagcdn.com/24x18/${code.toLocaleLowerCase()}.png`}
                    alt=""
                    ml="10px"
                    alignSelf="center"
                  />
                </Flex>
              )}
            </Flex>

            {description &&
              (description.length > 200 ? (
                <Box>
                  {!more ? (
                    <Text fontSize="14px" textAlign="center" mt="10px" color="white">
                      {truncate(description, 240)}
                    </Text>
                  ) : (
                    <Text fontSize="14px" textAlign="center" mt="10px" color="white">
                      {description}
                    </Text>
                  )}

                  {more ? (
                    <Text
                      color="blue.400"
                      textAlign="center"
                      mt="2px"
                      cursor="pointer"
                      fontSize="14px"
                      onClick={() => setMore(false)}
                    >
                      Show Less <Icon as={FiChevronDown} />
                    </Text>
                  ) : (
                    <Text
                      color="blue.400"
                      textAlign="center"
                      mt="2px"
                      cursor="pointer"
                      fontSize="14px"
                      onClick={() => setMore(true)}
                    >
                      Show More <Icon as={FiChevronDown} />
                    </Text>
                  )}
                </Box>
              ) : (
                <Text fontSize="14px" textAlign="center" mt="10px" color="white">
                  {description}
                </Text>
              ))}

            <Flex
              borderWidth={1}
              borderColor={colorMode === 'dark' ? '#333' : null}
              borderRadius={8}
              mt="30px"
              fontSize="13px"
              w={{ base: '100%', md: '480px' }}
              // color="white"
              bg={bgColor[colorMode]}
            >
              <Flex
                flex="1"
                p="9px"
                borderRightWidth={1}
                borderColor={colorMode === 'dark' ? '#333' : '#DCDCDC'}
                justifyContent="center"
                flexDirection={{ base: 'column', md: 'row' }}
              >
                <Text fontWeight="bold">{statistics?.owners || '-'}</Text>
                <Text fontWeight="normal" ml={{ base: 0, md: '5px' }}>
                  Owners
                </Text>
              </Flex>
              <Flex
                flex="1"
                p="9px"
                borderRightWidth={1}
                borderColor={colorMode === 'dark' ? '#333' : '#DCDCDC'}
                justifyContent="center"
                flexDirection={{ base: 'column', md: 'row' }}
              >
                <Text fontWeight="bold">{statistics?.sold === 0 ? '-' : statistics?.sold}</Text>
                <Text fontWeight="normal" ml={{ base: 0, md: '5px' }}>
                  Sold
                </Text>
              </Flex>
              <Flex flex="1" p="9px" justifyContent="center" flexDirection={{ base: 'column', md: 'row' }}>
                <Text fontWeight="bold">{priceOne(statistics?.minimum_price / 100) || '-'}</Text>
                <Text fontWeight="normal" ml={{ base: 0, md: '5px' }}>
                  Floor
                </Text>
              </Flex>
            </Flex>

            <Flex id="social" mt="20px">
              <HStack spacing="24px" fontSize="14px">
                {userData?.facebook && (
                  <IconSocial
                    icon={FaFacebook}
                    color="#0079ff"
                    uri={`https://facebook.com/${
                      validURL(userData?.facebook) ? parseUsername(userData?.facebook) : userData?.facebook
                    }`}
                  />
                )}
                {userData?.instagram && (
                  <IconSocial
                    icon={FaInstagram}
                    color="#ff0b92"
                    uri={`https://www.instagram.com/${
                      validURL(userData?.instagram) ? parseUsername(userData?.instagram) : userData?.instagram
                    }`}
                  />
                )}
                {userData?.twitter && (
                  <IconSocial
                    icon={FaTwitter}
                    color="#55acee"
                    uri={`https://www.twitter.com/${
                      validURL(userData?.twitter) ? parseUsername(userData?.twitter) : userData?.twitter
                    }`}
                  />
                )}
                {userData?.linkedin && (
                  <IconSocial icon={FaLinkedin} color="#0A66C2" uri={setHttp(userData?.linkedin)} />
                )}
                {userData?.discord && <IconSocial icon={FaDiscord} color="#5865F2" uri={setHttp(userData?.discord)} />}
                {userData?.website && <IconSocial icon={MdMonitor} color="#7f7f7f" uri={setHttp(userData?.website)} />}
              </HStack>
            </Flex>
          </Flex>
        </Box>
      </Container>
    </Box>
  );
};
export default CardProfileCollection;
